<template>
  <el-drawer :title="title" size="40%" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
    <span slot="title" class="dialog-footer">
      {{ title }}
      <span  @click="handleRefresh" style="cursor: pointer;margin-left: 20px;color: #0000ff;">
        <i  class="icon-font el-icon-refresh "
        :class="{ 'refresh-icon': refreshIcon }"></i>刷新
      </span>


    </span>
    <div>
      <el-table border stripe ref="singleTable" :data="tableData" highlight-current-row
      v-loading="loading"
      element-loading-text="正在刷新任务列表"
        @current-change="handleCurrentChange" style="width: 100%;cursor: pointer">
        <el-table-column property="task_id" label="任务ID" width="200">
        </el-table-column>
        <el-table-column property="created_at" label="创建时间" width="150">
        </el-table-column>
        <el-table-column property="task_content" label="任务内容">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" :content="row.task_content" placement="top">
              <div slot="content">
                <div v-html="row.task_content"></div>
              </div>
              <div class="clamp-1" style="overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;">{{ row.task_content }}</div>
            </el-tooltip>

          </template>

        </el-table-column>

        <el-table-column property="status" label="任务状态">
          <template slot-scope="{ row }">
            <div>
              <el-tag v-if="row.status == 'pending'" type="info">正在导入中</el-tag>
              <el-tag v-else-if="row.status == 'success'" type="success">导入成功</el-tag>

              <el-tag v-else type="danger">导入失败</el-tag>
              <div v-if="row.status == 'danger'">
                 <el-tooltip class="item" effect="dark" :content="row.error" placement="top">
              <div class="clamp-1" style="overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;color: red;">失败原因：{{ row.error }}</div>
            </el-tooltip>
              </div>
            </div>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next" :current-page.sync="currentPage" :total="total"
        :page-size="pagesize" @current-change="handleCurrentChangePage" />
    </div>
  </el-drawer>
</template>
<script>
export default {
  props: {
    title: {
      type: [String, Object],
      default: "提示",
    },
    data: {
      type: [Object],
      default: {}
    }
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pagesize: 10,
      drawer: false,
      direction: 'rtl',
      currentRow: null,
      tableData: [],
      refreshIcon: false,
      loading: false,
    };
  },
  created() {
    this.getList()
  },
  methods: {
    handleRefresh() {
      this.refreshIcon = true
      
      this.getList()
      setTimeout(()=>{
        this.refreshIcon = false
      },2*1000)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.drawer = false
        })
        .catch(_ => { });
    },
    async getList() {
      this.loading=true
      var { data: res } = await this.$http.get("/api/ai/getCompleteUserInfoTasks", {
        params: {
          page: this.currentPage,
          pageSize: this.pagesize,
        },
        baseURL: process.env.VUE_APP_AI_URL
      });
      this.total = res.data.total_count
      this.tableData = res.data.list
      this.loading=false
    },
    /**
     * 切换创建人
     * @param val
     * @returns {Promise<void>}
     */
    async toggle() {
      var { data: res } = await this.$http.get("/admin/Activity/changeManager", {
        params: {
          activityId: this.data.id,
          managerId: this.currentRow.id,
        },
      });
      if (res.errorCode == 200) {
        this.$emit('updata')
        this.$message({
          type: 'success',
          message: '切换成功!'
        });
      }
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      this.$confirm(`是否将创建人切换为“${val.name}”`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        console.log(this.data)
        this.toggle()
        this.drawer = false
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消!'
        });
      });
    },
    /**
     * 分页切换
     * @param val
     */
    handleCurrentChangePage(val) {
      this.currentPage = val;
      this.getList();
    },
  }
};
</script>
<style scoped lang="less">
.refresh-icon{
  transition: all 0.5s;
  transform: rotate(360deg);
}
</style>